import { render, staticRenderFns } from "./BoningExportTable.vue?vue&type=template&id=596ca132&scoped=true"
import script from "./BoningExportTable.vue?vue&type=script&lang=js"
export * from "./BoningExportTable.vue?vue&type=script&lang=js"
import style0 from "./BoningExportTable.vue?vue&type=style&index=0&id=596ca132&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "596ca132",
  null
  
)

export default component.exports